import React, {useRef} from 'react';
import {useReactToPrint} from 'react-to-print';

import {
    Dialog,
    DialogContent,
    Slide,
    Container,
    Stack,
    Grid,
    AppBar,
    Toolbar,
    IconButton,
    Typography
} from '@mui/material';
import {Close} from "@mui/icons-material";
import {Cover} from "../items/fragments/_styled_components";
import {isEmpty} from "lodash";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const ProductCard = ({item}) => {


    const totalShipping = item?.shipping?.map(one => Number(one?.quantity));
    const totalS = (isEmpty(totalShipping) ? [0] : totalShipping)?.reduce((a, b) => a + b)

    const totalPos = item?.pos?.map(one => Number(one?.quantity));
    const totalP = (isEmpty(totalPos) ? [0] : totalPos)?.reduce((a, b) => a + b)

    return (
        <Grid container>
            <Grid item xs={3}>
                <Cover
                    width={200}
                    height={200}
                    src={item?.ImageUrl}
                />
            </Grid>

            <Grid item xs={9}>
                <Stack direction={'column'} spacing={2}>

                    <Typography variant={'h6'}>
                        {item?.Name}
                    </Typography>

                    <Stack direction={'row'} justifyContent={'space-between'}>
                        <Stack direction={'column'}>
                            <Typography variant={'subtitle1'} sx={{fontWeight: 'bold'}}>
                                Barcode
                            </Typography>
                            <Typography variant={'body2'}>
                                {item?.Barcode || '---'}
                            </Typography>
                        </Stack>

                        <Stack direction={'column'}>
                            <Typography variant={'subtitle1'} sx={{fontWeight: 'bold'}}>
                                Prosoft Id
                            </Typography>
                            <Typography variant={'body2'}>
                                {item?.InternalId}
                            </Typography>
                        </Stack>

                    </Stack>


                    <Stack direction={'row'} justifyContent={'space-between'}>
                        <Stack direction={'column'}>
                            <Typography variant={'subtitle1'} sx={{fontWeight: 'bold'}}>
                                Sell Price
                            </Typography>
                            <Typography variant={'body2'}>
                                {item?.SellPrice || item?.Price || item?.NewPrice || '0'}
                            </Typography>
                        </Stack>

                        <Stack direction={'column'}>
                            <Typography variant={'subtitle1'} sx={{fontWeight: 'bold'}}>
                                Quantity in warehouse
                            </Typography>
                            <Typography variant={'body2'}>
                                {`Dekon: ${item?.Stock?.Dekon || 0} Cassablanca: ${item?.Stock?.Cassablanca || 0}`}
                            </Typography>
                        </Stack>

                    </Stack>


                    <Stack direction={'row'} justifyContent={'space-between'}>
                        <Stack direction={'column'}>
                            <Typography variant={'subtitle1'} sx={{fontWeight: 'bold'}}>
                                Quantity in Po
                            </Typography>
                            <Typography variant={'body2'}>
                                {String(totalP) || '0'}
                            </Typography>
                        </Stack>

                        <Stack direction={'column'}>
                            <Typography variant={'subtitle1'} sx={{fontWeight: 'bold'}}>
                                Quantity in shipping
                            </Typography>
                            <Typography variant={'body2'}>
                                {String(totalS) || '0'}
                            </Typography>
                        </Stack>

                    </Stack>


                </Stack>
            </Grid>


        </Grid>
    )
}

export default function InventoryPdfExport({data = [], open = false, onClose}) {

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    return (
        <Dialog open={open} onClose={onClose} TransitionComponent={Transition} fullScreen>
            <AppBar sx={{position: 'relative'}}>
                <Toolbar sx={{justifyContent: 'space-between'}}>

                    <Typography sx={{ml: 2, flex: 1}} variant="h6" component="div">
                        PDF
                    </Typography>

                    <Stack direction={'row'} spacing={1}>
                        <IconButton
                            color="inherit"
                            onClick={handlePrint}
                            aria-label="print"
                        >
                            <PictureAsPdfIcon/>
                        </IconButton>

                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={onClose}
                            aria-label="close"
                        >
                            <Close/>
                        </IconButton>
                    </Stack>

                </Toolbar>

            </AppBar>

            <DialogContent ref={componentRef}>
                <Container maxWidth={'md'}>

                    <Typography variant={'h4'} sx={{py: 2, pb: 5}}>
                        List of Products
                    </Typography>

                    <Stack direction={'column'} spacing={3}>
                        {
                            data?.map(item => (
                                <ProductCard
                                    key={item?.id}
                                    item={item}
                                />
                            ))
                        }
                    </Stack>
                </Container>
            </DialogContent>

        </Dialog>
    )
}